module.exports = {
    header:{
      index:"首页",
      project:"项目介绍",
      regional:'区位交通',
      design:"设计理念",
      brand:'品牌服务',
      rental:"租赁信息",
      footer:"联系我们",
      iconTitle:"创意办公 轻奢商业",
      experience:'办公体验',
      service:'增值服务'
    },
    // 项目介绍
    project:{
      project:"项目介绍",
      describe:'西虹桥德必易园，定位西安数字文化创新中心，依托西安丰富的文科教资源和创新主体资源，以高新技术为核心产业，以轻公司生态圈为运营理念，为企业提供面向未来的智慧办公体验，打造融合科创、文创产业的新高地。',
      contentOne:'西虹桥商务区，聚焦<strong>“长三角一体化发展”</strong>和<strong>“中国国际进口博览会”</strong>的重大战略，规划面积19平方公里，是虹桥国际开放枢纽重要组成部分。',
      contentTwo:'西虹桥德必易园坐落于西虹桥商务区核心板块，<strong>依托虹桥交通枢纽便利和国家会展中心辐射带动</strong>，打造总部企业集聚地。园区延承德必易园的“简与变”设计风格，打造50000㎡无边界创意树林，激活西虹桥创意新势力。',
      contentThree:'园区重点引进数字科技、文化创意、商务服务等文科创产业，是<strong>青浦区重点扶持</strong>的产业园之一。',
      MetroLine2:"地铁二号线",
      belltower:"钟楼",
      XingqingPark:"兴庆公园",
      Pagoda:"大雁塔",
      Happyforestbelt:"幸福林带",
      MetroLine3:"地铁三号线",
      TechnologyUniversity:"西安理工大学",
      JiaotongUniversity:"西安交通大学",
      MetroLine6:"地铁六号线",
      Phase:"二期在建",
      Engineering:"西安工程大学"
    },
    // 区位交通
    regional:{
      regional:"区位交通",
      describe:"双轨地铁环绕 畅享便利繁华\n西安主城区 紧邻东二环",
      iconDrive:'驾车',
      iconTransit:'公交',
      iconMetro:'地铁',
      Areabitmap:'区位图',
      describeRing:'虹桥机场/虹桥火车站',
      describeXiaozhai:"上海国家会展中心",
      describeQujiang:"人民广场",
      describeRailway:'西安火车站',
      describeNorth:'西安北客站',
      describeAirport:'西安咸阳国际机场',
      transitDescribe:"白徐线、徐泾3路、青凤徐专线等多辆公交直达",
      metroTitle:"地铁",
      metroDescribe:"17号线蟠龙路地铁站",
      drive:'驾车'
    },
    // 办公体验
    experience:{
      design:"办公体验",
      TaohuaTitle:"园区活力衔接城市边界",
      TaohuaDescribe:"既是楼宇的边界，又是另一种庭院。不断释放出人与空间互动的活力，在城市的建筑缝隙中打开无边界的空间，在人生活的缝隙中构建出立体的精神花园。",
      receptionTitle:"精装入驻，节省30%空间成本",
      receptionDescribe:"精装户型，独立办公空间，高品质家具全配，品牌墙、会议室、储藏室、咖啡厅、餐厅、便利店一应俱全，可容纳30-60人，让您省去烦恼，实现拎包入驻。",
      HardcoverTitle:"有温度的健康工作环境",
      HardcoverDescribe:"户外运动场、休闲咖吧、数字智慧餐厅、创意书屋、健身房、母婴关爱室、智能睡眠舱等配套设施，让紧张的工作心情得到舒缓，给予员工有温度的健康工作环境。",
      wehomeTitle:"专业会议层提质增效",
      wehomeDescribe:"4-100人不同规模会议室，配备巨幕投影、电视投影、音响、玻璃板等设施，满足品牌发布、讲座论坛、培训沙龙等会务需求，让每一次头脑风暴都见证高效。",
      commercialTitle:"多功能共享区域",
      commercialDescribe:"室内、室外均提供共享区域，身处共享经济的时代，就在触手可及的空间，让灵感与商业进行思维的碰撞。"
    },
    // 设计理念
    design:{
      design:"设计理念",
      TaohuaTitle:"闹世桃花坞 静享庭院式办公环境",
      TaohuaDescribe:"穿过佳木繁秀的竹林,踏过曲径通幽的小径,\n三重庭院静享,触目皆自然,繁华闹市中一隅创意静土,\n让办公脱去仆仆风尘,于城市间感知生命、微风、暖阳。",
      receptionTitle:"城市会客厅 办公生态新场景",
      receptionDescribe:"9米挑高,拾阶而上,路演展览、社交会晤,\n商务休闲随性切换,多元化共享空间体验。",
      HardcoverTitle:"精装拎包入驻 德必SPACE 纵享高效办公",
      HardcoverDescribe:"德必SPACE一站式office精装,提供共享会议室、会客区、水吧台等公共设施,\n为企业节约30%空间预算,帮助企业降低经营、商务、时间成本。",
      wehomeTitle:"wehome空间智慧管理平台 建立企业服务生态物联网络",
      wehomeDescribe:"依托于德必集团多年园区运营管理经验,以及经验丰富的团队,坚持自主创新,将科研结果与“互联网＋”结合,自主创新wehome空间智慧管理平台,提供园区整体智能解决方案,打造场景全触达的集成型平台,增加场所认同,让“智慧园区”从构想变为现实。",
      commercialTitle:"星光里·商业街区 足不出园优享多元生活",
      commercialDescribe:"办公、生活、商务、社交、休闲一站式创意商业街区,为入驻白领提供楼上办公,\n楼下休闲的全新体验。"
    },
    // 品牌服务
    brand:{
      brand:"入驻即享10大增值服务",
      title_01:'创业服务',
      title_02:'工商注册服务',
      title_03:'财务顾问服务',
      title_04:'法律和政策服务',
      title_05:'上市对接顾问服务',
      title_06:'人才服务',
      title_07:'品牌推广服务',
      title_08:'Wehome线上服务',
      title_09:'社群活动',
      title_10:'国际社群节',
    },
    // 租赁信息
    rental:{
      rental:"租赁信息",
      Delivery:'交付标准\n毛坯/精装',
      totalArea:'总面积\n50000㎡',
      DividedArea:'单元分割\n100-4000㎡',
      FloorHeight:'分布式空调',
      ParkingLot:"400个车位",
      SharedRoom:"配套设施：班车、健身房、\n餐厅、花园、\n共享会议层、篮球公园等",
      conditioning:'中央空调\n分体空调',
      Monitoring:'24H安保\n监控服务',
      PublicArea:"公共区域\nWiFi覆盖",
      Restaurant:"白领餐厅",
      Garden:"屋顶花园",
      WaterBar:"水吧台",
      viewPlan:"查看平面图"
    },
    // 底部
    footer:{
      iconTitle:"办公/商业租赁热线",
      address:"地址：上海市青浦区华徐公路605号",
      phone:'021-69773808',
      addressDescribe:"西安·碑林·公园南路26号(地铁3/6号线)",
      position:"扫码了解更多信息",
      information:'德必集团（股票代码：300947），专业致力于成为中国\n领先的文科创产业全价值链服务商。目前已在上海、北\n京、杭州、南京、苏州、成都、长沙、西安、合肥，以\n及美国硅谷、意大利佛罗伦萨等落地数十个文化创意产\n业园区，成功吸纳了一批批优秀的文科创企业入驻，实\n现了产业集聚和生态闭环。'

    }

}



// WEBPACK FOOTER //
// ./src/assets/lang/zh.js